<ion-content class="background with-field"  [fullscreen]="true">

  <ion-grid class="grid">
    <ion-row class="row ion-align-items-center ion-text-center">
      <ion-col>
        <div id="fantaballottaggi-icon">
          <img src="/assets/images/icon-alpha-optimized.png" [ngClass]="{'animate__animated animate__bounceInDown animate__slower': animate }">
        </div>
        <div id="powered-by">
          <img src="/assets/images/powered-by.png">
        </div>
        <div id="fantapazz-logo">
          <img src="/assets/images/fantapazz-logo.png">
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

</ion-content>
